import Vue from "vue";
import Router from "vue-router";
import Main from "@/views/Main";
import Daily from "@/views/Daily";
import Endless from "@/views/Endless";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "Main",
      component: Main,
    },
    {
      path: "/daily",
      name: "Daily",
      component: Daily,
    },
    {
      path: "/daily/:score",
      name: "DailyScore",
      component: Daily,
    },
    {
      path: "/endless",
      name: "Endless",
      component: Endless,
    },
    {
      path: "/endless/:score",
      name: "EndlessScore",
      component: Endless,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js